import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import '@/App.css';
import LandingPage from './pages/LandingPage';
import DirectoryPage from './pages/DirectoryPage';
import AllDoctorsPage from './pages/AllDoctorsPage';
import DoctorProfilePage from './pages/DoctorProfilePage';
import LoginPage from './pages/LoginPage';
import DoctorRegistration from './pages/DoctorRegistration';
import FacilityRegistration from './pages/FacilityRegistration';
import AllFacilitiesPage from './pages/AllFacilitiesPage';
import FacilityProfilePage from './pages/FacilityProfilePage';
import FacilityComparePage from './pages/FacilityComparePage';
import PatientDashboard from './pages/PatientDashboard';
import DoctorDashboard from './pages/DoctorDashboard';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import CMSManagement from './pages/CMSManagement';
import PitchDecksPage from './pages/PitchDecksPage';
import TermsPage from './pages/TermsPage';
import AIConfigPage from './pages/AIConfigPage';
import ContentCreationPage from './pages/ContentCreationPage';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import SymptomCheckerChat from './components/SymptomCheckerChat';
import { Toaster } from './components/ui/sonner';

function AppRouter() {
  const location = useLocation();
  
  // Check for session_id in URL fragment
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/directory" element={<DirectoryPage />} />
        <Route path="/all-doctors" element={<AllDoctorsPage />} />
        <Route path="/doctor/:doctorId" element={<DoctorProfilePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/terms" element={<TermsPage />} />
        
        <Route path="/doctor/register" element={<DoctorRegistration />} />
        <Route path="/facility/register" element={<FacilityRegistration />} />
        <Route path="/facilities" element={<AllFacilitiesPage />} />
        <Route path="/facilities/compare" element={<FacilityComparePage />} />
        <Route path="/facility/:facilityId" element={<FacilityProfilePage />} />
        
        <Route path="/patient/dashboard" element={
          <ProtectedRoute>
            <PatientDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/doctor/dashboard" element={
          <ProtectedRoute requiredRole="doctor">
            <DoctorDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/dashboard" element={
          <ProtectedRoute requiredRole="super_admin">
            <SuperAdminDashboard />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/cms" element={
          <ProtectedRoute requiredRole="super_admin">
            <CMSManagement />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/ai-config" element={
          <ProtectedRoute requiredRole="super_admin">
            <AIConfigPage />
          </ProtectedRoute>
        } />
        
        <Route path="/admin/content-studio" element={
          <ProtectedRoute requiredRole="super_admin">
            <ContentCreationPage />
          </ProtectedRoute>
        } />
        
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        <Route path="/pitch-decks" element={<PitchDecksPage />} />
      </Routes>
      
      {/* Global Symptom Checker Chat Widget */}
      <SymptomCheckerChat />
      
      <Toaster position="top-right" richColors />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;